// Shared formatters for deductible (omavastuu) views.

export function formatEur(val: string | number | null | undefined): string {
  return (
    Number(val ?? 0).toLocaleString('fi-FI', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }) + ' €'
  )
}

export function formatDateTime(isoStr: string | null | undefined): string {
  if (!isoStr) return ''
  const d = new Date(isoStr)
  return (
    d.toLocaleDateString('fi-FI') +
    ' ' +
    d.toLocaleTimeString('fi-FI', { hour: '2-digit', minute: '2-digit' })
  )
}

export function formatPeriod(yearMonth: string): string {
  // "2026-08-01" -> "8/2026"; correction periods (day != 1) show the full date
  const [y, m, d] = yearMonth.split('-')
  if (d && d !== '01') return `${Number(d)}.${Number(m)}.${y}`
  return `${Number(m)}/${y}`
}
